import { ResponseWrapper, ErrorWrapper } from './utils';
import getEnv from '@/utils/env';
import axiosInstance from '@/services/api/http.service';

const API_URL = getEnv('VUE_APP_LOG_OAP_HOST') || 'http://localhost:8083';

export class LOGService {
  static get entity() {
    return 'log';
  }

  static async getSourcesList(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-service-traffic`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getFieldsList(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-service-traffic/metadata`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getTagsList(sourceData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-service-traffic/tags`,
        sourceData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getLogTableData(sourceData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-service-traffic/log-data`,
        sourceData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async addLogRule(ruleData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-rule`,
        ruleData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getLogRuleData(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-rule/all`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteLogRule(grokId) {
    try {
      const response = await new axiosInstance({ auth: true }).delete(
        `${API_URL}/log-rule/${grokId}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getGraphData(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-metrics/histogram`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async applySqlQuery(queryData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/sql/execute`,
        queryData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async applyTextQuery(queryData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/text/execute`,
        queryData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async downloadLogs(queryData, config) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/commonLog/download`,
        queryData,
        config,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getRecentSqlQuery(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-recent-query/all`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getSavedSearchTableData(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/push-query/all`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async addSavedSearchData(searchData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/push-query/create`,
        searchData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteSavedSearch(savedSearchId) {
    try {
      const response = await new axiosInstance({ auth: true }).delete(
        `${API_URL}/push-query/${savedSearchId}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async checkSavedSearchNameExists(searchData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/push-query/name-exists`,
        searchData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async applyAPMCorrelationQuery(queryData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/correlation/apm`,
        queryData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
